export default {
  create( _, data ) {
    /* if ( !VALID_CHECKLIST_ITEM_STATES.includes( state ) ) {
      throw new Error('Invalid checklist item state:', state)
    } */
    return {
      name:     data.name     || "",
      parent:   data.parent   || "0",
      done:     data.done     || false,
      duration: data.duration || 0,
      sortidx:  data.sortidx  || 0,
      collapse: data.collapse || null
    }
  },

  fields: {
    name: { validate_bolt_type: 'String' },
    parent: { validate_bolt_type: 'String' },
    done: { validate_bolt_type: 'Boolean' },
    duration: { validate_bolt_type: 'Number' },
    sortidx: { validate_bolt_type: 'Number' },
    collapse: { validate_bolt_type: 'Boolean' },
  }
};
